import common from '@/services/common'

export default {
  memberInfo() {
    return common.execute('get', '/api/user/v1/memberinfo', null, () => console.warn('Unable to find current member info'))
  },
  getRoles() {
    return common.execute('get', `/api/user/v1/roles`).then(
      result => result.roles
    )
  },
  getRolesForClub(club) {
    return common.execute('get', `/api/user/v1/clubs/${club}/roles`).then(
      result => result.roles
    )
  },
  getMembers() {
    return common.execute('get', '/api/user/v1/members').then(
      result => result.members
    )
  },
  getMember(login, errorFn) {
    return common.execute('get', `/api/user/v1/members/${login}`, null, errorFn)
  },
  getOkta(login, errorFn) {
    return common.execute('get', `/api/user/v1/okta/${login}`, null, errorFn)
  },
  getMemberRoles(login) {
    return common.execute('get', `/api/user/v1/members/${login}/roles`)
  },
  createMember(memberInfo) {
    return common.execute('post', '/api/user/v1/members', memberInfo)
  },
  deleteMember(login) {
    return common.execute('delete', `/api/user/v1/members/${login}`)
  },
  addRole(login, role) {
    return common.execute(
      'put',
      `/api/user/v1/members/${login}/roles/${role}`,
      null
    )
  },
  removeRole(login, role) {
    return common.execute(
      'delete',
      `/api/user/v1/members/${login}/roles/${role}`,
      null
    )
  },
}